import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.477 6.477 2 12 2A10 10 0 112 12zm8.73 3.35l5.62-5.62a.5.5 0 000-.69l-.53-.53a.5.5 0 00-.7 0l-4.74 4.74-1.5-1.49a.48.48 0 00-.7 0l-.53.53a.5.5 0 000 .71l2.38 2.35a.48.48 0 00.7 0z" fill="currentColor" /></svg>);